import React, { useState } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'

import { hasErrors } from './'
import { formatDateTime } from 'src/core/utils'
import FormError from './FormError'

const propTypes = {
  id: PropTypes.string.isRequired,
}

const DateTimeField = ({ id, field, form, ...props }) => {
  const [startDate, setStartDate] = useState(null)
  const { onBlur } = field
  return (
    <>
      <div className="mb-6">
        <DatePicker
          dateFormat="dd/MM/yyyy p"
          showPopperArrow={false}
          showTimeSelect
          timeFormat="p"
          timeIntervals={15}
          autoComplete="off"
          onBlur={() => {
            form.setFieldTouched(id, true)
            onBlur()
          }}
          selected={startDate}
          onChange={date => {
            setStartDate(date)
            date
              ? form.setFieldValue(id, formatDateTime(date))
              : form.setFieldValue(id, '')
          }}
          className={`w-full py-4 px-6 text-lg rounded-lg bg-primary-lighter placeholder-black ${
            hasErrors({ field, form })
              ? 'border border-error'
              : 'border border-transparent'
          }`}
        />
        {hasErrors({ field, form }) && (
          <FormError error={form.errors[field.name]} />
        )}
      </div>
    </>
  )
}

DateTimeField.propTypes = propTypes

export default DateTimeField
